import React from 'react';

interface LevelIconProps {
  color?: string;
  size?: number;
  strokeWidth?: number;
  activeBars?: number; // number of bars to color (1-4)
}

const LevelIcon: React.FC<LevelIconProps> = ({
  color = 'currentColor',
  size = 42,
  strokeWidth = 2,
  activeBars = 0
}) => {
  // Heights of bars from left to right
  const barHeights = [3, 6, 9, 12];
  
  return (
    <svg
      stroke={color}
      fill="none"
      strokeWidth={strokeWidth}
      viewBox="0 0 24 24"
      strokeLinecap="round"
      strokeLinejoin="round"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      {barHeights.map((height, index) => (
        <path
          key={index}
          d={`M${6 + (index * 4)} 18l0 -${height}`}
          stroke={index < activeBars ? color : 'var(--color-light-blue)'}
        />
      ))}
    </svg>
  );
};

export default LevelIcon;